import { getOrgAndIntroducerAndAdvisorFiltersDiscovery } from '../api/org_introducer_advisor_filters'
import { Resolvers } from '../generated/resolvers'

const OrgAndIntroducerAndAdvisorFilter: Resolvers = {
  Query: {
    orgAndIntroducerAndAdvisorFiltersDiscovery: (_parent, { input }) => getOrgAndIntroducerAndAdvisorFiltersDiscovery(input),
  },
}

export default OrgAndIntroducerAndAdvisorFilter
